import * as Actions from '../../actions/table'

const initialState = {
  data: [],
  selected: {
    data: null,
    isLoading: false,
    error: false
  },
  takeawayTable: null,
  isLoading: false,
  error: false
}

const tablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_TABLES: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.GET_TABLES_SUCCESS: {
      return {
        ...state,
        data: action.payload.grouped,
        takeawayTable: action.payload.takeawayTable,
        isLoading: false,
        error: false
      }
    }
    case Actions.GET_TABLES_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    case Actions.GET_TABLE: case Actions.SET_TABLE: {
      return {
        ...state,
        selected: {
          ...state.selected,
          isLoading: true,
          error: false
        }

      }
    }
    case Actions.GET_TABLE_SUCCESS: case Actions.SET_TABLE_SUCCESS: {
      return {
        ...state,
        selected: {
          data: action.payload,
          isLoading: false,
          error: false
        }
      }
    }
    case Actions.GET_TABLE_ERROR: case Actions.SET_TABLE_ERROR: {
      return {
        ...state,
        selected: {
          data: null,
          isLoading: false,
          error: action.error
        }
      }
    }

    case Actions.SET_TAKEAWAY_TABLE: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.SET_TAKEAWAY_TABLE_SUCCESS: {
      return {
        ...state,
        takeawayTable: action.payload,
        isLoading: false,
        error: false
      }
    }
    case Actions.SET_TAKEAWAY_TABLE_ERROR: {
      return {
        ...state,
        takeawayTable: null,
        isLoading: false,
        error: action.error
      }
    }

    case Actions.ADD_TABLE: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.ADD_TABLE_SUCCESS: {
      if (state.data[action.payload.section]) { state.data[action.payload.section].push(action.payload) } else { state.data[action.payload.section] = [action.payload] }

      return {
        ...state,
        isLoading: false,
        error: false
      }
    }
    case Actions.ADD_TABLE_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }
    case Actions.UPDATE_TABLE: {
      return {
        data: state.data,
        isLoading: true,
        error: false
      }
    }
    case Actions.UPDATE_TABLE_SUCCESS: {
      const section              = action.payload.section
      const index                = state.data[section].findIndex(p => p._id === action.payload._id)
      state.data[section][index] = action.payload
      return {
        ...state,
        isLoading: false,
        error: false
      }
    }
    case Actions.UPDATE_TABLE_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    case Actions.DELETE_TABLE: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.DELETE_TABLE_SUCCESS: {
      state.data[action.payload.section] = state.data[action.payload.section].filter(p => p._id !== action.payload._id)
      return {
        ...state,
        isLoading: false,
        error: false
      }
    }
    case Actions.DELETE_TABLE_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    case Actions.DELETE_TABLES: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.DELETE_TABLES_SUCCESS: {
      return {
        ...state,
        data: state.data.filter(o => !action.payload.includes(o._id)),
        isLoading: false,
        error: false
      }
    }
    case Actions.DELETE_TABLES_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    default: {
      return state
    }
  }
}

export default tablesReducer
